<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/move-step5')"></span>
    </div>
    <div class="title">服务保险</div>
    <div class="box-img">
      <img class="full-image" src="../../assets/img/global/insurance.png">
    </div>
    <div class="text">
      <div class="text-main">
        到家提供付费保险以保障服务中的意外损坏情况，如需购买，可点击下方加号选择保险额度
          <div class="insurance-style">
            （ <span class="color-orange">
            <span @click="$router.push('/move-insurance-info');">点击了解更多保险介绍</span>
            </span> ）
          </div>
      </div>
    </div>
    <div class="option-container">
      <div class="item">
        <span class="qty-label">保障额度</span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='temp.insurance_cover'>
            <template v-slot:symbol>$</template>
          </v-counter>
        </div>
      </div>

      <div class="item" v-if="car_insurance==200">
        <span class="qty-label">保险费</span>
        <span class="qty-label" v-if="temp.insurance_cover==0">$0（未投险）</span>
        <span class="qty-label" v-else>${{((temp.insurance_cover)/200)*5}}</span>
      </div>

      <div class="item" v-if="car_insurance==400">
        <span class="qty-label">保险费</span>
        <span class="qty-label" v-if="temp.insurance_cover==0">$0（未投险）</span>
        <span class="qty-label" v-else>${{((temp.insurance_cover)/400)*5}}</span>
      </div>

      <div class="item" v-if="car_insurance==600">
        <span class="qty-label">保险费</span>
        <span class="qty-label" v-if="temp.insurance_cover==0">$0（未投险）</span>
        <span class="qty-label" v-else>${{((temp.insurance_cover)/600)*5}}</span>
      </div>


    </div>


    <div class="btn-box-fix">
       <div class="slogan"><span class="icon-check-circle color-orange"></span> 点击下一步即表明同意
        <span class="color-orange">
          <span @click="$router.push('/move-insurance-info');">到家服务保险条款</span>
        </span>
      </div> 
      <div class="btn-container">
        <div class="btn active" @click="checkSubmit()">下一步</div>
      </div>
    </div>

    <img :src="pixelURL('move','baoxian')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'baggage-step0',
  data () {
    return {
      order:{},
      temp:{
        insurance_cover:0
      }
    }
  },
  methods: {
    checkSubmit(){
      if(this.car_insurance==200){
        this.order.data.insurance_amount = ((this.temp.insurance_cover)/200)*5;
      }
      if(this.car_insurance==400){
        this.order.data.insurance_amount = ((this.temp.insurance_cover)/400)*5;
      }
      if(this.car_insurance==600){
        this.order.data.insurance_amount = ((this.temp.insurance_cover)/600)*5;
      }
      this.orderUpdateAll('/move-step6');
    },

    isSkipable(){
      if(this.order.data.move_other_valuables){
        return true;
      }
      let obj = this.tempValuable;
      let summary = 0;
      for (let item in obj) {
        summary = summary + obj[item];
      }
      if(summary){
        return true;
      }
      else{
        return false;
      }
    },
    plus: function () {
      if(this.car_insurance==200){
        if(this.temp.insurance_cover>=5000){
          this.temp.insurance_cover = this.temp.insurance_cover +1000;
        }
        else{
          this.temp.insurance_cover = this.temp.insurance_cover +200;
        }
        if(this.temp.insurance_cover>20000){
          this.temp.insurance_cover=20000;
        }
      }

      if(this.car_insurance==400){
        if(this.temp.insurance_cover>=8000){
          this.temp.insurance_cover = this.temp.insurance_cover +1600;
        }
        else{
          this.temp.insurance_cover = this.temp.insurance_cover +400;
        }
        if(this.temp.insurance_cover>50000){
          this.temp.insurance_cover=50000;
        }
      }

      if(this.car_insurance==600){
        if(this.temp.insurance_cover>=10000){
          this.temp.insurance_cover = this.temp.insurance_cover +2400;
        }
        else{
          this.temp.insurance_cover = this.temp.insurance_cover +600;
        }
        if(this.temp.insurance_cover>99000){
          this.temp.insurance_cover=99000;
        }
      }

		},
    minus: function () {
      if(this.car_insurance==200){
        this.temp.insurance_cover = this.temp.insurance_cover -200;
        if(this.temp.insurance_cover<=0){
          this.temp.insurance_cover=0;
        }
      }
      if(this.car_insurance==400){
        this.temp.insurance_cover = this.temp.insurance_cover -400;
        if(this.temp.insurance_cover<=0){
          this.temp.insurance_cover=0;
        }
      }
      if(this.car_insurance==600){
        this.temp.insurance_cover = this.temp.insurance_cover -600;
        if(this.temp.insurance_cover<=0){
          this.temp.insurance_cover=0;
        }
      }
		},
  },
  computed: {
    car_insurance: function () {
      if(this.order.data.move_car=="1"){
        return 200;
      }
      if(this.order.data.move_car=="2" || this.order.data.move_car=="3"){
        return 400;
      }
      if(this.order.data.move_car=="4" || this.order.data.move_car=="5"){
        return 600;
      }
    },
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
        if(this.order.data.insurance_amount){
          if(this.car_insurance==200){
            this.temp.insurance_cover = this.order.data.insurance_amount*40;
          }
          if(this.car_insurance==400){
            this.temp.insurance_cover = this.order.data.insurance_amount*80;
          }
          if(this.car_insurance==600){
            this.temp.insurance_cover = this.order.data.insurance_amount*120;
          }
        }
        else{
          this.temp.insurance_cover = 0;
        }
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.box-img{
  width:80%;
  margin:6px auto 0 auto;
  text-align:center;
}


.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}

.btn-box-fix .btn.active{
  margin-left:0;
  margin-top:0;
}

.text{
  padding:1em 40px;
  .text-main{
    color:#888;
    text-align:center;
  }
}

.option-container{
  padding:0 40px;
}
.qty-label{
	display: inline-block;
	font-weight: 100;
	vertical-align: top;
	padding: 12px 0 0 0;
	color: #000;
}
.item{
  display: flex;
	justify-content:space-between;
  align-items:left;
  margin-bottom:6px;
  img{
    width:60px;
  }
  .counter{
    padding-top:8px;
    margin-left:14px;
  }
}

.other-text{
  font-size:0.9em;
  border-left:0.5px solid #e5e5e5;
  border-right:0.5px solid #e5e5e5;
}
.container /deep/ .qty .number{
  width:80px;
}

.insurance-style{
  margin-top:6px;
  font-size:0.9em;
}
</style>



// WEBPACK FOOTER //
// src/pages/move/insurance.vue